import { createFileRoute, Outlet } from "@tanstack/react-router";
import { ErrorBoundaryComponent } from "#/components/error-boundary";

export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/$school/insights/lesson-administration/timeouts",
)({
  component: () => <Outlet />,
  errorComponent: LessonAdministrationTimeoutsError,
});

function LessonAdministrationTimeoutsError({ error }: { error: unknown }) {
  const params = Route.useParams();
  return <ErrorBoundaryComponent error={error} params={params} />;
}
